import { render, staticRenderFns } from "./TurnoverPerMonthInformation.vue?vue&type=template&id=85438cac&"
import script from "./TurnoverPerMonthInformation.vue?vue&type=script&lang=ts&"
export * from "./TurnoverPerMonthInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports